import api from "./Api";

class LabelDescricaoService {
  GetLabelDescricao(payload) {
    return api.get("/v1/labelDescricao/" + payload).then((response) => {
      return response.data;
    });
  }

  PostLabelDescricao(payload) {
    return api.post("/v1/labelDescricao/", payload).then((response) => {
      return response.data;
    });
  }

  PutLabelDescricao(payload) {
    return api.put("/v1/labelDescricao/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteLabelDescricao(payload) {
    return api.delete("/v1/labelDescricao/" + payload).then((response) => {
      return response.data;
    });
  }

  GetLabelDescricaoOData(payload) {
    return api.get("/OData/LabelDescricao" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new LabelDescricaoService();
